export default __webpack_public_path__ + "static/solutionCardRight-75b384597806e430bcdf0456c69a651e.png";